import React, { useState } from 'react'
import { CustomWorkItem } from './CustomWorkItem'
import { formatDecimalHoursToHM } from '../../../utils/formatDecimalHoursToHM'

export const CustomWorkUser = (
  {
    userData,
    setDeleteModal,
    positionId,
    getData
  }
) => {

  const {
    user,
    data,
    totalMinutes
  } = userData

  const [isOpen, setIsOpen] = useState(true)

  const onOpenDetails = () => {
    setIsOpen(!isOpen)
  }

  const formatMinutesToReadable = (minutes) => {
    return formatDecimalHoursToHM(Math.round(minutes / 60 * 1000) / 1000)
  }



  return (
    <div className={`text-Regular(16_18) pt-[0.6rem] flex flex-col items-start [&:not(:first-child)]:border-t [&:not(:first-child)]:border-[#c9c9c9]`}>
      <div className={`flex items-center gap-[12px] hover:cursor-pointer`} onClick={onOpenDetails}>
        <div>{user.username}:</div>
        <div className={`font-bold`}>{formatMinutesToReadable(totalMinutes)}</div>
        <div className={`flex items-center`}>
          <i className={`${isOpen
            ? 'rotate-180'
            : ''} text-Accent/Blue icon-arrow text-Regular(12_14) duration-300 ease-in-out m-auto  inline-flex items-center justify-center`}></i>
        </div>
      </div>
      <div className={`pl-[1rem] pt-[0.5rem] flex flex-col gap-[8px] transition-[max_height] mt-[4px]
      ${isOpen ? 'h-auto max-h-[1000px] duration-300 ease-in-out' : 'max-h-[0] pointer-events-none opacity-0'}`}>
        {data.map((item) => (
          <CustomWorkItem key={item.id} data={item} userId={user.id} setDeleteModal={setDeleteModal} getData={getData} positionId={positionId}/>
        ))}
      </div>
    </div>
  )
}